import React,{useEffect} from "react";
import { useLocation } from "react-router-dom";

function OnScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div></div>;
}

export default OnScroll;
